<div class="static-tag-container">
  <app-static-tag [color]="data.color">{{ data.text }}</app-static-tag>
  <div *ngIf="data?.icon" class="icon-container">
    <i [ngClass]="data.icon.iconClass" (click)="onClick()"></i>
  </div>
</div>
